import React from "react";
import "./opportunity.css";

const Opportunity = ({ data }) => {
  return (
    <section className="opportunity">
      <div className="opportunity__container">

        {/* LEFT SIDE */}
        <div className="opportunity__left">

          <div className="opportunity__accent"></div>

          <div className="opportunity__heading-content">

            {data.sectionLabel && (
              <div className="opportunity__label">
                {data.sectionLabel}
              </div>
            )}

            <h2 className="opportunity__heading">
              {data.heading.map((item, index) => (
                <span
                  key={index}
                  className={
                    item.highlight
                      ? "opportunity__highlight"
                      : ""
                  }
                >
                  {item.text}
                  {index < data.heading.length - 1 && <br />}
                </span>
              ))}
            </h2>

          </div>

        </div>


        {/* RIGHT SIDE */}
        <div className="opportunity__right">

          {/* Paragraphs */}
          {data.content.paragraphs?.map((paragraph, index) => (
            <p
              className="opportunity__paragraph"
              key={index}
            >
              {paragraph}
            </p>
          ))}


          {/* Tags */}
          {data.content.tags?.length > 0 && (
            <div className="opportunity__tags">

              {data.content.tags.map((tag, index) =>
                tag.trim() !== "" ? (
                  <span className="opportunity__tag" key={index}>
                    {tag}
                  </span>
                ) : (
                  <div className="breakline"></div>
                )
              )}


            </div>
          )}

        </div>

      </div>
    </section>
  );
};

export default Opportunity;